export default "__VITE_ASSET__qeJ8AUci__"